import type { IServiceErrorKind } from '@/lib/constants/errors'
import type { IServiceError } from '@/types/error'
import log from '@/providers/log'

export default function getServiceError({
  error,
  message: userErrorMessage,
  kind,
}: {
  error: unknown
  message: string
  kind?: IServiceErrorKind
}): IServiceError {
  const devErrorMessage =
    error instanceof Error ? `${userErrorMessage}: ${error.message}` : `${userErrorMessage}: Unknown error`
  log.error(devErrorMessage)
  return { error: { message: userErrorMessage, ...(kind ? { kind } : {}) } }
}
